import { actionCreatorFactory } from 'typescript-fsa'
import { Event } from '../../types'

const actionCreator = actionCreatorFactory()

export const registerEvents = actionCreator<Event[]>('registerEvents')
